import { Container } from './Container'
import { Content } from './Content'

export const Footer = () => (
	<Container>
		<Content>© 2026 Subaio</Content>
	</Container>
)
